import {useState} from 'react';
import streamSaver from 'streamsaver';
import {baseURL} from 'shared/hooks/use-api';
import {ProjectionProps} from '../api-table';
import {errorNotification} from 'shared/services/notification';
import useToken from 'modules/auth/atoms/use-token';

export const DOCUMENT_TYPE = {
  XLSX: 'xlsx',
  PDF: 'pdf',
} as const;

interface Props {
  url: string;
  projection: ProjectionProps;
  type: typeof DOCUMENT_TYPE[keyof typeof DOCUMENT_TYPE];
}

const useTableState = ({projection, url, type}: Props) => {
  const [loadingExportData, setLoadingExportData] = useState(false);
  const {token} = useToken();

  const handleExportData = async () => {
    setLoadingExportData(true);

    let params;

    if (projection) {
      const {values, filter} = projection;

      const filters = Object.keys(filter?.filters ?? {}).reduce(
        (object, key) => {
          return {
            ...object,
            [key]: JSON.stringify(filter?.filters[key]),
          };
        },
        {},
      );

      params = new URLSearchParams({
        projection: values!.join(' '),
        ...filters,
      }).toString();
    }

    try {
      const urlModified = `${baseURL}${url}/${type}${
        params ? `?${params}` : ''
      }`;

      const {body} = await fetch(urlModified, {
        headers: {
          language: 'pt_BR',
          Authorization: `Bearer ${token}`,
        },
      });

      const fileStream = streamSaver.createWriteStream(`planilha.${type}`);
      body?.pipeTo(fileStream);
    } catch (error) {
      errorNotification({
        title: 'Erro ao exportar dados',
        message: (error as any)?.response?.data?.message,
      });
    }
    setLoadingExportData(false);
  };

  return {
    loadingExportData,
    handleExportData,
  };
};

export default useTableState;
